import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

export const Root = styled(Box)({
  height: 'calc(100vh - 125px)',
  overflowY: 'auto',
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
});

export const Content = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const Message = styled(Paper)(({ theme }) => ({
  display: 'flex',
  width: 'fit-content',
  maxWidth: '80%',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
}));

export const MessageContainer = styled(Box)({
  display: 'flex',
});

export const UserMessage = styled(Message)({
  backgroundColor: '#C1EAFF',
  marginLeft: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
});

export const AssistantMessage = styled(Message)({
  backgroundColor: '#E8D0FF',
  marginRight: 'auto',
});

export const ClickablePaper = styled(AssistantMessage)({
  cursor: 'pointer',
  outline: 'none',
  '&:focus': {
    boxShadow: `0 0 0 3px ${'#7C3AED'}55`,
  },
});

export const UserIconWrapper = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const BrandIconWrapper = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const ScrollToBottomIconWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));

export const EndIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifySelf: 'flex-end',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}));

export const Markdown = styled(Box)({
  '& > h1:first-of-type, & > h2:first-of-type, & > h3:first-of-type, & > h4:first-of-type, & > h5:first-of-type, & > h6:first-of-type':
    {
      marginTop: 0,
    },
  '& p': {
    marginTop: 0,
  },
  '& > p:last-of-type': {
    marginBottom: 0,
  },
});

export const ToolCall = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(0),
}));
